import { render, staticRenderFns } from "./ConsultaRethus.vue?vue&type=template&id=26e47e63&"
import script from "./ConsultaRethus.vue?vue&type=script&lang=js&"
export * from "./ConsultaRethus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports